"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/outlet.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.outlet
 * @name rinca.apps.outlet
 * @packageName rinca.apps
 * @description A module that includes the outlet component.
 */
angular.module('rinca.apps.outlet', ['ui.router'])
    .controller('OutletController', controllers_1.OutletController)
    .service('_outlet', services_1.OutletService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/outlet/index.ts
// module id = 375
// module chunks = 0